<template>
    <div class="body">
        <div class="login-page">
            <div class="imgLogin">
                <img src="@/assets/logo-white.png" alt="Logo">
            </div>

            <div class="form">
                <form class="login-form">
                    <input v-model="formData.email" placeholder="Login" maxlength="20" type="text">
                    <input v-model="formData.password" placeholder="Senha" maxlength="10" type="password">
                    <button type="button">Entrar</button>
                </form>
                <div class="d-flex justify-content-between mt-3">
                    <a href="/recover-password">Esqueceu a senha</a>
                    <a href="">Cadastre-se</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'LoginView',

    data() {
        return {
            formData: {
                email: '',
                password: ''
            },
        }
    },
}
</script>

<style scoped>
@import url(https://fonts.googleapis.com/css?family=Roboto:300);

.body {
    width: 100vw;
    height: 100vh;
    background-color: #2d2d2d !important;
}

.login-page {
    margin: auto;
    width: 450px;
    padding: 8% 0 0;
}

.form {
    z-index: 1;
    padding: 45px;
    position: relative;
    text-align: center;
    background: #FFFFFF;
    margin: 0 auto 100px;
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2), 0 5px 5px 0 rgba(0, 0, 0, 0.24);
}

.form p {
    font-family: "Roboto", sans-serif;
    margin: 0;
    text-align: left;
    padding: 0 0 0 5%;
}

.form a {
    width: 48%;
    padding: 10px;
    color: #000000;
    font-size: 14px;
    text-align: center;
    text-decoration: none;
    text-transform: uppercase;
    background-color: #eeeeee;
}


.form input {
    font-family: "Roboto", sans-serif;
    border: 0;
    outline: 0;
    width: 100%;
    padding: 15px;
    font-size: 14px;
    margin: 0 0 15px;
    background: #f2f2f2;
    box-sizing: border-box;
}

.form button {
    font-family: "Roboto", sans-serif;
    border: 0;
    outline: 0;
    width: 100%;
    padding: 15px;
    color: #FFFFFF;
    font-size: 14px;
    cursor: pointer;
    background: #335c4c;
    text-transform: uppercase;
    transition: all 0.3s ease;
    -webkit-transition: all 0.3s ease;
}

.form button:hover,
.form button:active,
.form button:focus {
    background: #335c4c;
}

.login-page .imgLogin img {
    display: block;
    margin-left: auto;
    max-height: 100px;
    margin-right: auto;
}

.login-page .imgLogin {
    padding: 5% 0;
    background: #335c4c;
}

@media (max-width: 767px) {
    .login-page {
        width: 96%;

    }

    .login-page img {
        max-width: 200px;
    }

    .form {
        padding: 20px;
    }
}
</style>